import React from 'react'
import createSvgIcon from '../createSvgIcon'

export default createSvgIcon(
  <>
    <defs>
      <linearGradient
        id="successGradient"
        x1="12"
        y1="0"
        x2="12"
        y2="24"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#82E69F" />
        <stop offset="1" stopColor="#4F9F52" />
      </linearGradient>
    </defs>
    <rect width="24" height="24" rx="6" fill="url(#successGradient)" />
    <path
      d="M17.3739 8.70409C17.0051 8.31963 16.3907 8.31854 16.0205 8.7017L10.6154 14.2962L7.97522 11.5711C7.60681 11.1909 6.9967 11.1913 6.62882 11.5721C6.27809 11.9351 6.27809 12.5108 6.62882 12.8738L9.89621 16.2556C10.2893 16.6625 10.9414 16.6625 11.3346 16.2556L17.3716 10.0071C17.7225 9.64395 17.7235 9.06845 17.3739 8.70409Z"
      fill="white"
    />
  </>,
  'Success',
  24
)
